import React from 'react';

const Diamond = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => (
  <svg
    cx={cx}
    cy={cy}
    x={cx - 5}
    y={cy - 5}
    fill={color}
    width={10}
    height={10}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  >
    <path fill={color} stroke={color} d="M5 .757L9.243 5 5 9.243.757 5z" />
  </svg>
);

export default Diamond;
